import { none } from "fp-ts/Option";
import { Lens } from "@discovery/prelude/lib/control/lens";
export const initialState = {
    userM: none,
    configM: none,
    homeRoute: "",
    playerheight: 0,
    availableLocations: ["in"],
    isKidsPage: false,
    isUserPremiumFromPartners: false,
    userProfilesLength: 0,
    pageTitle: "",
    isParentalLockAccess: false,
    showAllAccessPopUp: false,
    isMostPopularListsHidden: false,
    videoId: "",
    tabs: {
        currentSelectedSeason: "",
    },
};
export const _PlayerHeight = Lens.prop("playerheight");
export const _availableLocations = Lens.prop("availableLocations");
export const _IsUserPremiumFromPartners = Lens.prop("isUserPremiumFromPartners");
export const _userProfilesLength = Lens.prop("userProfilesLength");
export const _isParentalLockAccess = Lens.prop("isParentalLockAccess");
export const _user = Lens.prop("userM");
export const _Config = Lens.prop("configM");
export const _HomeRoute = Lens.prop("homeRoute");
export const _IsKidsPage = Lens.prop("isKidsPage");
export const _pageTitle = Lens.prop("pageTitle");
export const _showAllAccessPopUp = Lens.prop("showAllAccessPopUp");
export const _isMostPopularListsHidden = Lens.prop("isMostPopularListsHidden");
export const _videoId = Lens.prop("videoId");
export const _tabs = Lens.prop("tabs");

